<template>
	<div :class="{
      'calendar-events-day': true,
      today: item.today === true,
      isDisabled: item.isDisabled === true,
      isHolidays: item.isHolidays
    }" >
		<tool-tip
				v-if="item.isHolidays"
				:text="holidayText"
				margin="0"
				content-class="top"
				:position="{ top: 'top' }"
		>
			<div class="date">
				{{ formattedDate }}
			</div>
		</tool-tip>
		<div v-else class="date">
			{{ formattedDate }}
		</div>
		<div v-if="item.users" class="dots">
			<div class="dot"
			     v-for="(user, index) in item.users"
			     :key="index"
			>
				<span :style="{ color: user.color }">●</span>
			</div>
		</div>
	</div>
</template>

<script>
import ToolTip from "@/shared/ToolTip/ToolTip.vue";

export default {
	name: "CalendarEventsDay",
	components: { ToolTip },
	props: {
		item: Object
	},
	computed: {
		formattedDate() {
			// Преобразуем item.date и возвращаем только день
			return this.item.date.split("-")[2]; // Берём третью часть из "2024-12-29"
		},
		holidayText() {
			// Добавляем статический текст к значению item.isHolidays
			return `Holiday 🤟🥳💃 :  ${ this.item.isHolidays }`;
		},
	},
};
</script>

<style scoped lang="scss">
@import "calendar-events-day";
</style>
